module.exports = __webpack_public_path__ + "static/media/has_containers.e276ae8e.svg";